// extracted by mini-css-extract-plugin
export default {"title":"jlkXfj6R_l5eOXp15uJo","list":"zdaxkEbTj0wLUX0WiWlo","item":"WACRNolhUCCfd6sLgBNa"};